// thrux-upsell-dialog.js — "offer buy more" dialog on PURCHASE NOW.
//
// When the customer submits a buy box whose selected tier is 1 or 2, offer the
// FOUNDERS KIT (3 cans, one of each flavor). When the tier is 3 AND the post-flip
// DOUBLE IT tier (qty 6) is rendered, offer DOUBLE IT. Otherwise no dialog.
//
// The dialog never auto-opens, shows at most once per session per tier, is
// reduced-motion safe, and is disabled store-wide by the buy box attribute
// data-upsell-dialog="false" (settings.thrux_upsell_dialog).
//
// Mechanics: a single document-level CAPTURE-phase submit listener runs BEFORE
// product-page.js's own bubble-phase form 'submit' handler. When it decides to
// offer, it preventDefault + stopImmediatePropagation (so NO add happens yet) and
// opens the dialog. Accept clicks the target tier button — which runs all the
// normal product-page.js tier side effects (qty, mode, per-can flavors, price) —
// then re-submits the SAME form once. Decline / X / Esc / backdrop re-submit as
// is. A per-form __thruxUpsellProceed flag makes that single re-submit pass
// straight through to product-page.js, so tier math, the selling plan and the
// AddToCart pixel all fire exactly once. product-page.js is not modified.
(function () {
  if (window.__thruxUpsellDialogInit) return;
  window.__thruxUpsellDialogInit = true;

  var shownThisLoad = {};

  function shownKey(qty) { return 'thrux_upsell_shown_' + qty; }
  function wasShown(qty) {
    if (shownThisLoad[qty]) return true;
    try { return sessionStorage.getItem(shownKey(qty)) === '1'; } catch (e) { return false; }
  }
  function markShown(qty) {
    shownThisLoad[qty] = true;
    try { sessionStorage.setItem(shownKey(qty), '1'); } catch (e) {}
  }
  function money(cents) { return '$' + (cents / 100).toFixed(2); }
  function centsFromPrice(str) { return Math.round(parseFloat(str || '0') * 100); }

  // Move each dialog to <body> so its fixed overlay is viewport-relative even if a
  // buy-box ancestor establishes a containing block (e.g. a reveal transform). Each
  // dialog keeps data-upsell-for="<buy box id>" so we can pair it back at submit time.
  function portalDialogs() {
    document.querySelectorAll('[data-buy-box-upsell]').forEach(function (d) {
      if (d.parentNode !== document.body) document.body.appendChild(d);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', portalDialogs);
  else portalDialogs();

  function dialogFor(buyBox) {
    var id = buyBox.id;
    if (id) {
      var d = document.querySelector('[data-buy-box-upsell][data-upsell-for="' + id + '"]');
      if (d) return d;
    }
    // Fallback: dialog still nested inside the buy box (portal not yet run).
    return buyBox.querySelector('[data-buy-box-upsell]');
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('[data-buy-box-form]')) return;
    var buyBox = form.closest('[data-buy-box]');
    if (!buyBox) return;

    // A decision was already made for this form — let this submit add normally.
    if (form.__thruxUpsellProceed) { form.__thruxUpsellProceed = false; return; }

    if (buyBox.getAttribute('data-upsell-dialog') !== 'true') return; // disabled store-wide
    var dialog = dialogFor(buyBox);
    if (!dialog) return;

    var current = buyBox.querySelector('[data-tier][aria-checked="true"]');
    if (!current) return;
    var curQty = parseInt(current.getAttribute('data-qty'), 10);
    if (!curQty) return;

    var target = null, offerType = null;
    if (curQty === 1 || curQty === 2) {
      target = buyBox.querySelector('[data-tier][data-qty="3"]');
      offerType = 'founders';
    } else if (curQty === 3) {
      var six = buyBox.querySelector('[data-tier][data-qty="6"]');
      if (six) { target = six; offerType = 'double'; }
    }
    if (!target || !offerType) return;      // nothing to offer → normal add
    if (wasShown(curQty)) return;           // at most once per session per tier

    // On Subscribe, quote the computed subscription figures (data-sub-price) so the dialog matches
    // the tile prices; one-time uses data-price. Both are money-filtered in Liquid, never typed.
    var isSub = buyBox.getAttribute('data-purchase-type') === 'subscribe';
    function tierCents(el) {
      if (isSub) { var s = el.getAttribute('data-sub-price'); if (s) return centsFromPrice(s); }
      return centsFromPrice(el.getAttribute('data-price'));
    }
    var curTotal = tierCents(current);
    var tgtQty = parseInt(target.getAttribute('data-qty'), 10);
    var tgtTotal = tierCents(target);
    var deltaCans = tgtQty - curQty;
    var deltaCost = tgtTotal - curTotal;
    var perCan = Math.round(tgtTotal / tgtQty);
    if (deltaCans <= 0 || deltaCost <= 0) return; // never upsell to a worse/equal deal

    // Block the add and open the dialog.
    e.preventDefault();
    e.stopImmediatePropagation();
    markShown(curQty);
    openDialog(dialog, {
      offerType: offerType, deltaCans: deltaCans, deltaCost: deltaCost,
      perCan: perCan, target: target, form: form
    });
  }, true);

  function openDialog(dialog, ctx) {
    var isFounders = ctx.offerType === 'founders';
    var titleEl = dialog.querySelector('[data-upsell-title]');
    var subEl = dialog.querySelector('[data-upsell-sub]');
    var accept = dialog.querySelector('[data-upsell-accept]');
    var decline = dialog.querySelector('[data-upsell-decline]');
    var closeBtn = dialog.querySelector('[data-upsell-close]');
    var backdrop = dialog.querySelector('[data-upsell-backdrop]');
    var canWord = ctx.deltaCans === 1 ? 'can' : 'cans';

    if (titleEl) titleEl.textContent = isFounders ? 'Make it the Founders Kit?' : 'Double it?';
    if (subEl) {
      subEl.textContent = isFounders
        ? '3 cans, one of each flavor. Add ' + ctx.deltaCans + ' more ' + canWord + ' for ' +
          money(ctx.deltaCost) + '. That is ' + money(ctx.perCan) + ' a can.'
        : '6 cans at ' + money(ctx.perCan) + ' a can. Add ' + ctx.deltaCans + ' more ' + canWord +
          ' for ' + money(ctx.deltaCost) + '.';
    }
    if (accept) accept.textContent = isFounders ? 'Yes, make it 3 cans' : 'Yes, double it';

    var lastFocus = document.activeElement;

    function cleanup() {
      dialog.hidden = true;
      document.removeEventListener('keydown', onKey, true);
      if (accept) accept.onclick = null;
      if (decline) decline.onclick = null;
      if (closeBtn) closeBtn.onclick = null;
      if (backdrop) backdrop.onclick = null;
      try { if (lastFocus && lastFocus.focus) lastFocus.focus(); } catch (e) {}
    }
    function proceed(useTarget) {
      cleanup();
      if (useTarget && ctx.target) ctx.target.click(); // runs product-page.js tier side effects
      ctx.form.__thruxUpsellProceed = true;
      // Re-submit on the next tick so the tier-click DOM updates settle first.
      setTimeout(function () {
        if (ctx.form.requestSubmit) ctx.form.requestSubmit();
        else ctx.form.submit();
      }, 0);
    }
    function onKey(ev) {
      if (ev.key === 'Escape') { ev.preventDefault(); proceed(false); return; }
      if (ev.key === 'Tab') { trapFocus(ev); }
    }
    function trapFocus(ev) {
      var f = dialog.querySelectorAll('button:not([hidden])');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (ev.shiftKey && document.activeElement === first) { ev.preventDefault(); last.focus(); }
      else if (!ev.shiftKey && document.activeElement === last) { ev.preventDefault(); first.focus(); }
    }

    if (accept) accept.onclick = function () { proceed(true); };
    if (decline) decline.onclick = function () { proceed(false); };
    if (closeBtn) closeBtn.onclick = function () { proceed(false); }; // X = continue as is
    if (backdrop) backdrop.onclick = function () { proceed(false); }; // backdrop = continue as is
    document.addEventListener('keydown', onKey, true);

    dialog.hidden = false;
    if (accept) { try { accept.focus(); } catch (e) {} }
  }
})();
